import {
	BooleanEntityAttribute,
	DateEntityAttribute,
	Entity,
	EnumEntityAttribute,
	FloatEntityAttribute,
	IntegerEntityAttribute,
	ObjectEntityAttribute,
	StringEntityAttribute
} from '../base/Entity';
import PurchaseStatus from '../enums/PurchaseStatus';

/**
 * @name Purchase
 * @property {Number} Id
 * @property {Number} UserId
 * @property {Number} Months
 *
 * @property {Date} Date
 *
 * @property {PurchaseStatusValue} Status
 *
 * @property {String} CheckoutCode
 * @property {String} PaymentCode
 *
 * @property {Boolean} Fulfilled
 * @property {Boolean} Canceled
 *
 * @property {Number} GrossAmount
 * @property {Number} NetAmount
 *
 * @property {String} Description
 *
 * @property {Object} Items
 */
export class Purchase extends Entity {
}

Purchase.Register('Purchase');
Purchase.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('UserId'),
	new IntegerEntityAttribute('Months'),

	new DateEntityAttribute('Date'),


	new StringEntityAttribute('CheckoutCode'),
	new StringEntityAttribute('PaymentCode'),

	new BooleanEntityAttribute('Fulfilled'),
	new BooleanEntityAttribute('Canceled'),

	new FloatEntityAttribute('GrossAmount'),
	new FloatEntityAttribute('NetAmount'),

	new StringEntityAttribute('Description'),
	new EnumEntityAttribute('Status', PurchaseStatus),

	new ObjectEntityAttribute('Items')
];

export default Purchase;
